import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import { IdealistLogo } from 'components/Logo/IdealistLogo';
import { NoAmp } from 'containers/NoAmp';
import { colors, gutterWidth } from 'theme';

import { MobileSearchMenu } from './MobileSearchMenu';
import { PageHeaderSearchInputs } from './PageHeaderSearchInputs';
import { useStaffSearchMenu } from './useStaffSearchMenu';

type Props = {
  onSearch: (arg0: {
    query?: string;
    type?: string;
    searchType?: string;
  }) => void;
  qaId?: string;
  searchOpen: boolean;
  searchMode?: boolean;
  toggleSearch: (searchOpen: boolean) => void;
};

export function StaffPageHeaderSearchMenu({
  onSearch,
  qaId = 'staff-search-menu',
  searchOpen,
  searchMode,
  toggleSearch,
}: Props) {
  const staffProps = useStaffSearchMenu();

  return (
    <NoAmp>
      <MobileSearchMenu
        onClose={() => toggleSearch(false)}
        onSearch={() => toggleSearch(false)}
        searchMode={Boolean(searchMode)}
        searchOpen={searchOpen}
        selectedType={staffProps.selectedType}
        listingTypes={staffProps.listingTypes}
        clearSearchInput={staffProps.clearSearchInput}
        search={staffProps.search}
        query={staffProps.query}
        // @ts-expect-error Fix SearchLocation type
        searchLocation={staffProps.searchLocation}
        setListingType={staffProps.setListingType}
        setUserQuery={staffProps.setUserQuery}
        onLocationChange={staffProps.onLocationChange}
      />
      <Box
        data-qa-id={qaId}
        classes={['flex', 'align-center']}
        position="relative"
        width="100%"
        bg="white"
        pb={['36px', null, null, 16]}
        pt={['36px', null, null, 16]}
        px={gutterWidth / 2}
        height="100%"
        borderTop={`1px solid ${colors.inputGrey}`}
      >
        <Hide xs sm md>
          <Box height="100%" mr={[24, null, null, null, 40]}>
            <Box
              component="a"
              href="/staff"
              title="Idealist Staff"
              data-qa-id="header-logo-link"
              display="block"
              height="100%"
              lineHeight={0}
            >
              <IdealistLogo
                withText
                height={{ mobile: 36, desktop: 48 }}
                withStaffMarker
              />
            </Box>
          </Box>
        </Hide>
        <Box flex="1 1 auto" width="100%" height="100%">
          <PageHeaderSearchInputs
            onSearch={onSearch}
            selectedType={staffProps.selectedType}
            listingTypes={staffProps.listingTypes}
            clearSearchInput={staffProps.clearSearchInput}
            search={staffProps.search}
            query={staffProps.query}
            searchLocation={staffProps.searchLocation}
            setListingType={staffProps.setListingType}
            setQuery={staffProps.setUserQuery}
            onLocationChange={staffProps.onLocationChange}
          />
        </Box>
      </Box>
    </NoAmp>
  );
}
